import api from 'Application/api/api';

const getClients = (signal, configuration, filters = {}, searchQuery, details = true) => {
	const { page = 1, itemsPerPage = 20, sortBy = 'name', sortDirection = 'DESC' } = configuration;

	const params = {
		...filters,
		...configuration,
		details,
		query: searchQuery,
	};

	if (page) {
		params.page = page - 1;
	}

	if (itemsPerPage) {
		params.size = itemsPerPage;
	}

	if (sortBy && sortDirection) {
		params.sort = `${sortBy},${sortDirection}`;
	}

	return api.get('/clients/get-pageable', {
		params,
		signal,
		timeout: 60000,
	});
};

export default getClients;
